import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { BasicService } from 'src/app/shared/services/basic.service';
import { AccountsService } from '../../../accounts.service';
import { AccountInformation } from '../../../shared/models/account-information.model';

@Component({
  selector: 'app-kakaotalk-engagement-information',
  templateUrl: './kakaotalk-engagement-information.component.html',
  styleUrls: ['./kakaotalk-engagement-information.component.scss'],
})
export class KakaotalkEngagementInformationComponent {
  @Input() account: AccountInformation;

  form: FormGroup = this.formBuilder.group({
    senderKey: [''],
  });

  constructor(
    private formBuilder: FormBuilder,
    private accountsService: AccountsService,
    private basicService: BasicService
  ) {}

  save() {
    const model = this.form.getRawValue();
    const { senderKey } = model;
    this.basicService.showSpinner();
    this.accountsService
      .updateKakaotalkEngagementInformation(this.account.id, { sender_key: senderKey })
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe({
        next: () => {
          this.form.markAsPristine();
        },
      });
  }
}
